// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ContestPosts__list":"sx_a bhy_rc bhy_qx bhy_xr","ContestPosts__more":"sx_b bhy_vu bhy_b bhy_va bhy_sv"};